export default __webpack_public_path__ + "static/media/logo-canvas.5518363f.png";